import { REPORTEPP } from "@/config";
import { EmbeddedReport } from "../components/EmbeddedReport";

export default function ReportEPPPage() {
  return (
    <EmbeddedReport
      title="Reporte EPP"
      description="Registro de control de entrega de EPP por vale."
      src={REPORTEPP}
    />
  );
}
